export default __webpack_public_path__ + "16f9343db77a37c6edcf32050bad1d1f.svg";